export enum EXPORTACION_TYPES {
    EXPORTACION_SET_DATA_FACTURA = 'EXPORTACION_SET_DATA_FACTURA'
}